<template>
  <div v-if="showPopup" class="popup" @click.self="closePopup">
    <div class="popup-platform">
      <div class="popup-platform__close" @click="closePopup" />
      <div class="popup-platform__header">{{ $t("popup.platform.header") }}</div>
      <div class="popup-platform__text">{{ $t("popup.platform.text") }}</div>
      <div class="popup-platform__list">
        <a :href="linkAndroid" class="popup-platform__list-item">
          <img :src="androidImage" alt="Left To Survive Android" height="35" width="36" />
        </a>
        <a :href="linkApple" class="popup-platform__list-item">
          <img :src="appleImage" alt="Left To Survive Apple" height="38" width="39" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PopupPlatform",
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      linkAndroid: "https://lefttosurvive.onelink.me/FhQh/4kb7vtpn",
      linkApple: "https://my.games/play/lts",
    };
  },
  computed: {
    androidImage() {
      return require("../images/android.svg");
    },
    appleImage() {
      return require("../images/apple.svg");
    },
  },
  mounted() {
    window.addEventListener("keydown", this.escHandler);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.escHandler);
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    escHandler(e) {
      const key = e.key;
      if (key === "Escape") {
        this.closePopup();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/popup-platform";
</style>
